<script>
export default {

}
</script>



// WEBPACK FOOTER //
// assets/js/components/TheFooter.vue